module.exports = __webpack_public_path__ + "media/images/pic/meat-and-rosemary-401c2f24f5a61abc8e073dffd618906a.jpg";